import { httpPc } from "@/utils/httpPc";

export interface TagItem {
    tag_id: string;
    tag_name: string;
    selected?: boolean; 
}

export interface ClientTagsGroup {
    group_id: string;
    group_name: string;
    child: TagItem[];
}

export interface tagsList {
    list: ClientTagsGroup[];
}


export const getClientTagsList = ()=>{
  return httpPc.get<AxiosHttpPromise<tagsList>>(`/RestfulApi/clientTag/tag/full`)
}

export const getGoodsTagsList = ()=>{
    return httpPc.get<AxiosHttpPromise<tagsList>>(`/RestfulApi/goodsTag/tag/full`)
  }

